import { PayloadAction } from '@reduxjs/toolkit';
import { handleResponseError, handleResponseMessage } from 'app/rootSaga';
import { AxiosError } from 'axios';
import { CommonResponse } from 'models';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  MenuOrderInMenuGroup,
  SearchMenuOrderInMenuGroup,
  SearchSubMenuGroup,
  SubMenuGroup,
} from './models/submenulist';
import subMenuGroupService from './subMenuService';
import { subMenuGroupActions } from './subMenuSlice';

function* getSubMenuGroupList(action: PayloadAction<SearchSubMenuGroup>) {
  try {
    const params = action.payload;
    const response: CommonResponse<Array<SubMenuGroup>> = yield call(subMenuGroupService.getSubmenuGroupList, params);
    yield put(subMenuGroupActions.fetchSubMenuGroupSuccess(response));
  } catch (e) {
    yield put(subMenuGroupActions.fetchSubMenuGroupFailed());
    yield handleResponseError(e as AxiosError);
  }
}

function* getSubMenuGroupById(action: PayloadAction<{ subMenuGroupId: number; dataDate?: Date }>) {
  try {
    const params = action.payload;
    const response: CommonResponse<SubMenuGroup> = yield call(subMenuGroupService.getSubmenuGroup, params);
    yield put(subMenuGroupActions.fetchSubMenuGroupByIdSuccess(response));
  } catch (e) {
    yield put(subMenuGroupActions.fetchSubMenuGroupByIdFailed());
    yield handleResponseError(e as AxiosError);
  }
}

function* getSubMenuOrderInGroup(action: PayloadAction<SearchMenuOrderInMenuGroup>) {
  try {
    const params = action.payload;
    const response: CommonResponse<Array<MenuOrderInMenuGroup>> = yield call(
      subMenuGroupService.getSubMenuOrderInGroup,
      params
    );
    yield put(subMenuGroupActions.fetchOrderMenuInGroupSuccess(response));
  } catch (e) {
    yield put(subMenuGroupActions.fetchOrderMenuInGroupFailed());
    yield handleResponseError(e as AxiosError);
  }
}

function* updateSubMenuGroup(action: PayloadAction<SubMenuGroup>) {
  try {
    const params = action.payload;
    const response: CommonResponse<null> = yield call(subMenuGroupService.patchSubMenuGroup, params);
    yield put(subMenuGroupActions.patchSubMenuGroupSuccess(response));
    const resMessage: CommonResponse<null> = { ...response, data: null };
    yield handleResponseMessage(resMessage);
  } catch (e) {
    yield put(subMenuGroupActions.patchSubMenuGroupFailed());
    yield handleResponseError(e as AxiosError);
  }
}

function* updateSubMenuGroupOrder(action: PayloadAction<Array<MenuOrderInMenuGroup>>) {
  try {
    const params = action.payload;
    yield call(subMenuGroupService.patchSubMenuGroupOrder, params);
    yield put(subMenuGroupActions.patchSubMenuGroupOrderSuccess());
  } catch (e) {
    yield handleResponseError(e as AxiosError);
  }
}

export default function* subMenuGroupSaga() {
  yield takeLatest(subMenuGroupActions.fetchSubMenuGroup.type, getSubMenuGroupList);
  yield takeLatest(subMenuGroupActions.fetchSubMenuGroupById.type, getSubMenuGroupById);
  yield takeLatest(subMenuGroupActions.fetchOrderMenuInGroup.type, getSubMenuOrderInGroup);
  yield takeLatest(subMenuGroupActions.patchSubMenuGroup.type, updateSubMenuGroup);
  yield takeLatest(subMenuGroupActions.patchSubMenuGroupOrder.type, updateSubMenuGroupOrder);
}
